import React from 'react'
import EmpReg from '../Components/Employee/Emp/EmpReg'

const PersonalInformationPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      < EmpReg/>
    </div>
  )
}

export default PersonalInformationPage
